import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "prod-offer" };
const _hoisted_2 = { class: "prod-offer__wrap" };
const _hoisted_3 = { class: "prod-offer__block" };
const _hoisted_4 = {
    key: 0,
    class: "prod-offer__block"
};
const _hoisted_5 = { class: "prod-offer__block" };
import FilterSelector from "./FilterSelector.vue";
import { computed, inject, ref, watch } from "vue";
import OfferPrice from "./OfferPrice.vue";
import PreOrder from "./PreOrder.vue";
import HintTooltip from "./HintTooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferSelector',
    props: {
        product: { type: Object, required: true },
        types: { type: Array, required: true },
        hintTeleport: Object,
    },
    setup(__props) {
        const props = __props;
        const activeType = inject('type', ref(props.types[0]));
        const activeOffer = ref();
        const offerModel = inject('offer', ref(null));
        const isGiftSet = computed(() => activeType.value?.name === 'Набор');
        const offersByType = computed(() => props.product.offers.filter(offer => offer.type === activeType.value?.id));
        const filters = computed(() => offersByType.value.map(offer => ({
            id: offer.id,
            name: offer.volume ? `${offer.volume} мл` : offer.name,
            volume: offer.volume,
            flag: offer.distinction?.join(', ') || '',
            disabled: !offer.active,
        })));
        function selectDefaultOffer(items) {
            if (!items.length) {
                activeOffer.value = undefined;
                return;
            }
            activeOffer.value = items.find(item => item.id === activeOffer.value?.id)
                ?? items.find(item => item.volume && parseInt(item.volume) >= 15)
                ?? items[0];
        }
        // Пересчитываем и сразу синхронно ставим оффер при смене типа, чтобы избежать вспышки обложки
        watch(activeType, () => {
            selectDefaultOffer(filters.value);
        }, { immediate: true });
        if (offerModel.value) {
            const initialType = props.types.find(t => t.id === offerModel.value?.type);
            if (initialType) {
                activeType.value = initialType;
            }
            if (offersByType.value.find(o => o.id === offerModel.value?.id)) {
                activeOffer.value = filters.value.find(f => f.id === offerModel.value?.id);
            }
        }
        const filtersTitle = computed(() => isGiftSet.value ? 'Набор' : 'Объём');
        const offer = computed(() => {
            return offersByType.value.find(o => o.id === activeOffer.value?.id);
        });
        const hintButtonMessage = computed(() => {
            if (!offer.value) {
                return '';
            }
            const flags = [];
            if (offer.value.tester) {
                flags.push('тестер');
            }
            if (offer.value.sample) {
                flags.push('сэмпл');
            }
            if (offer.value.refill) {
                flags.push('refill');
            }
            return flags.length ? `Что такое ${flags.join('/')}?` : '';
        });
        watch(offer, value => {
            offerModel.value = value || null;
        });
        if (offer.value) {
            offerModel.value = offer.value;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(FilterSelector, {
                            title: "Тип",
                            name: "product_type",
                            items: __props.types,
                            modelValue: _unref(activeType),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(activeType) ? (activeType).value = $event : null))
                        }, null, 8 /* PROPS */, ["items", "modelValue"])
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (!_unref(activeType)?.disabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(FilterSelector, {
                                title: filtersTitle.value,
                                name: "product_filter",
                                items: filters.value,
                                modelValue: activeOffer.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((activeOffer).value = $event))
                            }, null, 8 /* PROPS */, ["title", "items", "modelValue"]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            (offer.value && (offer.value.tester || offer.value.refill || offer.value.sample))
                                ? (_openBlock(), _createBlock(HintTooltip, {
                                    key: 0,
                                    message: hintButtonMessage.value,
                                    "class-prefix": "prod-options__help",
                                    refill: offer.value.refill,
                                    tester: offer.value.tester,
                                    sample: offer.value.sample,
                                    teleport: __props.hintTeleport
                                }, null, 8 /* PROPS */, ["message", "refill", "tester", "sample", "teleport"]))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        (offer.value?.id)
                            ? (_openBlock(), _createBlock(OfferPrice, {
                                key: 0,
                                offer: offer.value
                            }, null, 8 /* PROPS */, ["offer"]))
                            : (_unref(activeType)?.disabled)
                                ? (_openBlock(), _createBlock(PreOrder, {
                                    key: 1,
                                    "product-id": __props.product.id,
                                    type: _unref(activeType)
                                }, null, 8 /* PROPS */, ["product-id", "type"]))
                                : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
